module.exports = __webpack_public_path__ + "static/media/avatar_default.16c4e251.svg";